import { ProposalCard } from './ProposalCard';
import type { Phase1Proposal, Phase2Proposal } from '@/lib/services/agent-wizard';

interface Phase3Props {
  phase1: Phase1Proposal;
  phase2: Phase2Proposal;
}

export function Phase3Review({ phase1, phase2 }: Phase3Props) {
  return (
    <div className="space-y-6">
      <ProposalCard title="Business Summary">
        <p className="text-sm text-foreground/80">{phase1.businessSummary}</p>
      </ProposalCard>

      <ProposalCard title="Offerings">
        <div className="space-y-2">
          {phase1.offerings.map((offering, i) => (
            <div key={i} className="text-sm">
              <span className="font-medium">{offering.name}</span>
              <span className="text-muted-foreground"> — {offering.description}</span>
            </div>
          ))}
        </div>
      </ProposalCard>

      <ProposalCard title="Ideal Customer Profile">
        <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
          <div>
            <span className="text-muted-foreground">Title:</span>{' '}
            <span className="font-medium">{phase1.icp.title}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Seniority:</span>{' '}
            <span className="font-medium">{phase1.icp.seniority}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Industry:</span>{' '}
            <span className="font-medium">{phase1.icp.industry}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Company Size:</span>{' '}
            <span className="font-medium">{phase1.icp.companySize}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Geography:</span>{' '}
            <span className="font-medium">{phase1.icp.geography}</span>
          </div>
          {phase1.icp.customFilters?.length > 0 && (
            <div className="col-span-2">
              <span className="text-muted-foreground">Filters:</span>{' '}
              <span className="font-medium">{phase1.icp.customFilters.join(', ')}</span>
            </div>
          )}
        </div>
      </ProposalCard>

      <ProposalCard title="Campaign Approach">
        <div className="space-y-3 text-sm">
          <div>
            <span className="text-muted-foreground">Goal:</span>{' '}
            <span className="font-medium">{phase2.outreachGoal}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Tone:</span>{' '}
            <span className="font-medium capitalize">{phase2.messagingTone}</span>
          </div>
        </div>
      </ProposalCard>

      <ProposalCard title="Email Sequence">
        <div className="space-y-3">
          {phase2.sequenceSteps.map((step, i) => (
            <div key={i} className="p-3 bg-muted/30 rounded-md text-sm">
              <div className="flex items-center justify-between mb-1">
                <span className="font-medium">
                  Email {i + 1}{i === 0 ? ' (Initial)' : ''}
                </span>
                {i > 0 && (
                  <span className="text-xs text-muted-foreground">
                    {step.delay} {step.delayUnit} after previous
                  </span>
                )}
              </div>
              <p className="text-muted-foreground">
                <span className="font-medium text-foreground/70">Subject:</span> {step.subject}
              </p>
              <p className="text-muted-foreground mt-1">
                {step.contentSketch}
              </p>
            </div>
          ))}
        </div>
      </ProposalCard>
    </div>
  );
}
